import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NavigationService } from "@app/services/navigation.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { IReportHistory } from "../../models/IDynamicReportLog";
import { ReportHistoryService } from "../../_services/report-history.service";
import './report-history-view.component.scss';

@UntilDestroy()
@Component({
    selector: 'report-history-view',
    template: require('./report-history-view.component.html')
})
export class ReportHistoryViewComponent implements OnInit {
    reportHistoryId: number;

    reportHistory: IReportHistory;
    pdfUrl: string

    loading: boolean;

    constructor(
        private readonly domSanitizer: DomSanitizer,
        private readonly navigationService: NavigationService,
        private readonly reportHistoryService: ReportHistoryService) {

    }

    ngOnInit(): void {
        this.reportHistoryId = this.navigationService.getRouteParam('reportHistoryId');

        this.getLog();
    }

    //--

    private getLog(): void {
        this.reportHistoryService.getSingleReportHistory(this.reportHistoryId).pipe(
            untilDestroyed(this)
        ).subscribe({
            next: history => {
                this.reportHistory = history;
            },
            complete: () => this.trustPdfUrl(this.reportHistory.pdfUrl),
            error: () => this.loading = false
        })
    }

    private trustPdfUrl(pdfUrl: string) {
        this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(pdfUrl) as any;
        this.loading = false;
    }

}
